import { render } from "./ItemIndexBookPassSheet.vue?vue&type=template&id=3581f560&scoped=true"
import script from "./ItemIndexBookPassSheet.vue?vue&type=script&lang=js"
export * from "./ItemIndexBookPassSheet.vue?vue&type=script&lang=js"

import "./ItemIndexBookPassSheet.vue?vue&type=style&index=0&id=3581f560&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3581f560"

export default script